const primaryBaseUrl = "https://atropine.ir/";
const backupBaseUrl = "https://drnayebzadehapp.ir/";

const generateMediaUrl = (fileUrl: string, format: string, baseUrl = primaryBaseUrl): string => {
  return `${baseUrl}${fileUrl}.${format}`;
};

const testMediaUrl = async (url: string): Promise<boolean> => {
  try {
    const response = await fetch(url, { method: "HEAD" });

    if (!response.ok) return false;

    const contentType = response.headers.get("Content-Type") || "";
    const isMedia =
      contentType.includes("video") ||
      contentType.includes("audio") ||
      contentType.includes("image");

    if (!isMedia) return false;

    return true;
  } catch {
    return false;
  }
};

const loadMediaWithFallback = async (fileUrl: string | null | undefined, format: string): Promise<string | null> => {
  if (!fileUrl) return null;

  const primaryUrl = generateMediaUrl(fileUrl, format);
  const isPrimaryValid = await testMediaUrl(primaryUrl);
  if (isPrimaryValid) return primaryUrl;

  const backupUrl = generateMediaUrl(fileUrl, format, backupBaseUrl);
  const isBackupValid = await testMediaUrl(backupUrl);
  if (isBackupValid) return backupUrl;

  return null;
};

export { generateMediaUrl, testMediaUrl, loadMediaWithFallback };



/**
 * Automatically detect which image format exists (jpg/png)
 * using both base URLs with fallback
 */
export const checkImageFormat = async (fileUrl : string) => {
  const formats = ["jpg", "png"];

  for (const base of [primaryBaseUrl, backupBaseUrl]) {
    for (const ext of formats) {
      const url = `${base}${fileUrl}.${ext}`;
      if (await testMediaUrl(url)) {
        return { format: ext, baseUrl: base };
      }
    }
  }

  // If nothing found
  return null;
};
